/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'tooltip';

/**
 * This is the component description.
 */
const Tooltip = ({
  id,
  className: userClassName,
  style,
  position,
  color,
  description,
  content,
  children
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName, `x-${color}`].filter(e => e).join(' '),
  style: style
}, /*#__PURE__*/React.createElement("div", {
  className: "tooltip-trigger-wrapper",
  "aria-describedby": description
}, children), /*#__PURE__*/React.createElement("div", {
  className: `tooltip-content ${position}`,
  role: "tooltip",
  id: description
}, content));
Tooltip.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string.isRequired,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX where the tooltip will be applied
   */
  children: PropTypes.node.isRequired,
  /**
   *  The content JSX that renders the tooltip content
   */
  content: PropTypes.node.isRequired,
  /**
   *  The text description  to identify the element that describes the tooltip
   */
  description: PropTypes.string.isRequired,
  /**
   * The position of the tooltip with respect to the trigger element
   */
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * The base color of the tooltip
   */
  color: PropTypes.string
};
Tooltip.defaultProps = {
  position: 'bottom',
  color: 'background-cards'
};
export default Tooltip;